import { useSyncExternalStore } from 'react'
import { getAuthReadySnapshot, initTokenManager, subscribeAuthReady } from './tokenManager'

export function useAuthReady() {
  initTokenManager()
  return useSyncExternalStore(subscribeAuthReady, getAuthReadySnapshot, getAuthReadySnapshot)
}

